import React, { Component } from 'react';
import BasicLayout from '../components/layout/BasicLayout';
import { API_ROOT } from '../config';
import { Row, Col, Select, Table, Button, message, Alert } from 'antd';
import LineChart from '../components/LineChart';
import { getNetwork, getErrorStatus } from '../utils/getNetwork';
import i18n from '../i18n';
const { Option } = Select;

const tableHeader = [
  { title: 'Наименование', dataIndex: 'title' },
  { title: 'Сфера', dataIndex: 'sphere' },
  { title: 'Отрасль', dataIndex: 'branch' },
  { title: 'Документ', dataIndex: 'document' },
  { title: 'Источник', dataIndex: 'source' }
];

class IndicatorView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: [],
      filter: {},
      fetching: true,
      tableData: [],
      series: [],
      lineData: [],
      data: [],
      selectedRows: [],
      selectedRowKeys: [],
      error: null
    };
  }

  componentDidMount() {
    this.getOptions();
  }

  handleApiError = (err) => {
    const accessDenied = getErrorStatus(err) === 403;
    this.setState({
      fetching: false,
      error: accessDenied
        ? i18n.t('error.doNotHaveAccessToViewThisModule')
        : i18n.t('error.loadingData')
    });
  };

  getOptions = () => {
    const placeholders = [
      { key: 'sphere', label: 'Сфера', width: 12 },
      { key: 'branch', label: 'Отрасль', width: 12 },
      { key: 'document', label: 'Документ', width: 24 },
      { key: 'source', label: 'Источник', width: 24 }
    ];
    const { filter } = this.state;
    let q = '?';
    Object.keys(filter).forEach(key => {
      q += key + '=' + filter[key] + '&';
    });
    q = q.slice(0, q.length - 1);
    getNetwork().get(API_ROOT + '/api/v1/indicators/get-options' + q).then(r => {
      this.setState({
        options: placeholders.map(e => ({
          ...e,
          options: r.data[e.key]
        })),
        error: null
      }, this.getTableData);
    }).catch(this.handleApiError);
  };

  getTableData = () => {
    const { filter } = this.state;
    let q = '?';
    Object.keys(filter).forEach(key => {
      q += key + '=' + filter[key] + '&';
    });
    q = q.slice(0, q.length - 1);
    getNetwork().get(API_ROOT + '/api/v1/indicators/get-table-indicators' + q).then(r => {
      this.setState({
        tableData: r.data,
        fetching: false
      });
    }).catch(this.handleApiError);
  };

  handleOption = (key, val) => {
    let filter = Object.assign(this.state.filter);
    if (val[0]) filter[key] = val;
    else delete filter[key];
    this.setState({ filter, fetching: true }, this.getOptions);
  };

  rowSelection = (selectedRowKeys, selectedRows) => {
    this.setState({ selectedRowKeys, selectedRows });
  };

  buildLineChart = () => {
    this.setState({ fetching: true });
    const { selectedRows } = this.state;
    Promise.all(selectedRows.map(e => getNetwork().get(API_ROOT + '/api/v1/indicators/get-indicator?title=' + e.title)))
      .then(r => {
        let data = r.map(e => e.data);
        let year_cats = Array.from(new Set(data.map(e => e.values).flat().map(e => e.year))).sort();
        let lineData = year_cats.map(year => {
          let obj = { category: year + '' };
          data.forEach(e => {
            obj[e.title] = e.values.find(el => el.year === year) ? e.values.find(el => el.year === year).fact : null;
          });
          return obj;
        });
        let series = data.map(e => ({
          name: e.title
        }));
        this.setState({
          lineData, series,
          fetching: false
        });
      })
      .catch(err => {
        const serverMessage = err && err.response && err.response.data && err.response.data.message;
        const text = serverMessage === 'Indicator not found'
          ? 'Индикатор не найден'
          : 'Не удалось построить график. Попробуйте позже';
        message.error(text);
        this.setState({ fetching: false, lineData: [], series: [] });
      });
  };

  render() {
    const { options, fetching, selectedRows, error } = this.state;
    if (error) {
      return (
        <BasicLayout>
          <Alert type="error" message={error} showIcon style={{ marginTop: '8px' }} />
        </BasicLayout>
      );
    }
    return (
      <BasicLayout>
        <Row gutter={5}>
          {options.map(item => (
            <Col
              span={item.width}
              key={item.key}
              style={{ marginBottom: '5px' }}
            >
              <Select
                placeholder={item.label}
                mode="multiple"
                style={{ width: '100%' }}
                allowClear
                onChange={val => this.handleOption(item.key, val)}
              >
                {item.options && item.options.map(e => (
                  <Option key={e} value={e}>
                    {e}
                  </Option>
                ))}
              </Select>
            </Col>
          ))}
        </Row>
        <Row>
          <Col span={8}>
            <p style={{ marginTop: '5px', fontWeight: 'bold' }}>Выберите индикаторы</p>
          </Col>
          <Col span={8}>
            <p style={{ marginTop: '5px', fontWeight: 'bold' }}>Количество выбранных индикаторов: {selectedRows.length}</p>
          </Col>
          <Col span={4}>
            <Button
              size="small"
              style={{ float: 'right', marginTop: '5px' }}
              type="primary"
              disabled={!selectedRows[0]}
              onClick={() => this.buildLineChart()}
            >Построить график</Button>
          </Col>
          <Col span={4}>
            <Button
              size="small"
              style={{ float: 'right', marginTop: '5px' }}
              type="primary"
              disabled={!selectedRows[0]}
              onClick={() => this.setState({ selectedRows: [], selectedRowKeys: [] })}
            >
              Сбросить
            </Button>
          </Col>
        </Row>
        <Table
          columns={tableHeader}
          rowSelection={{
            onChange: this.rowSelection,
            selectedRowKeys: this.state.selectedRowKeys
          }}
          rowKey="id"
          pagination={{ pageSize: 7 }}
          size="small"
          loading={fetching}
          dataSource={this.state.tableData}
        />
        <LineChart
          id="lineChartId1"
          data={this.state.lineData}
          height="50vh"
          series={this.state.series}
        />
      </BasicLayout>
    );
  }
}

export default IndicatorView;
